// extracted by css-extract-rspack-plugin
export default {"allocation":"allocation-JnGcmJ","removeBtn":"removeBtn-jMn_Ja"};